import { combineEpics } from 'redux-observable';
import capitalize from 'lodash/capitalize';
import { Observable } from 'rxjs/Observable';
import { reset } from 'redux-form';
import { formName } from '../components/LoginForm/constants';
import JWT from '../shared/jwt';
import ajax from '../shared/ajax';
import AppError from '../shared/AppError';
import { INVALID_TOKEN_CODE } from '../shared/constants';
import actionsAndConstants from '../shared/actionsAndConstants';

const {
  app: {
    actions: appActions,
    constants: appConstants
  },
  loginPage: {
    actions: loginPageActions,
    constants: loginPageConstants
  },
  topNavbar: {
    actions: topNavbarActions,
    constants: topNavbarConstants
  }
} = actionsAndConstants;

const changePassword = action$ =>
  action$.ofType(topNavbarConstants.changePassword)
    .switchMap(({ payload: { ajaxOptions = {}, dialogId = '' } } = {}) =>
      ajax(ajaxOptions)
        .mergeMap(({ detalle, descripcion }) => (
          Observable.of(
            appActions.hideDialog({ id: dialogId }),
            topNavbarActions.changePasswordSucceeded({
              data: detalle[0],
              alert: {
                message: descripcion || 'Ha cambiado su contraseña exitosamente',
                type: 'success'
              }
            })
          )
        ))
        .catch((error) => {
          if (error instanceof AppError && error.code === INVALID_TOKEN_CODE) {
            return Observable.of(
              appActions.hideDialog({ id: dialogId }),
              appActions.invalidToken({
                alert: { message: error.description }
              })
            );
          }
          return Observable.of(
            appActions.hideDialog({ id: dialogId }),
            topNavbarActions.changePasswordFailed({
              alert: { message: error.description || error.message },
            })
          );
        }));

const invalidToken = action$ =>
  action$.ofType(appConstants.invalidToken)
    .map(() => {
      JWT.forget();
      return topNavbarActions.logoutSucceeded({
        alert: { message: 'Su token es inválido o ha expirado. Inicie sesión nuevamente.' }
      });
    })
    .catch(() => {
      JWT.forget();
      return Observable.of(topNavbarActions.logoutSucceeded({
        alert: { message: 'Su token es inválido o ha expirado. Inicie sesión nuevamente.' }
      }));
    });

const login = action$ =>
  action$.ofType(loginPageConstants.login)
    .switchMap(({ payload: { ajaxOptions = {} } } = {}) =>
      ajax(ajaxOptions)
        .map(({ detalle, descripcion }) => {
          const { token } = detalle[0];
          try {
            if (JWT.validate(token)) {
              JWT.keep(token);
              const { claim: userInfo } = JWT.read(token);
              const {
                role = '',
                roleId = null,
                ...user = {}
              } = userInfo;
              user.role = {
                id: roleId,
                name: capitalize(role)
              };
              return loginPageActions.loginSucceeded({
                data: user,
                alert: {
                  message: descripcion || 'Ha iniciado sesión exitosamente.',
                  type: 'success'
                }
              });
            }
            throw Error('Se ha recibido un token inválido');
          } catch (error) {
            if (token) {
              JWT.forget();
            }
            throw Error('Se ha recibido un token inválido');
          }
        })
        .catch(error => (
          Observable.of(
            reset(formName),
            loginPageActions.loginFailed({
              alert: { message: error.description || error.message }
            })
          )
        )),
    );

const logout = action$ =>
  action$.ofType(topNavbarConstants.logout)
    .switchMap(({ payload: { ajaxOptions = {} } } = {}) =>
      ajax(ajaxOptions)
        .map(({ descripcion }) => {
          JWT.forget();
          return topNavbarActions.logoutSucceeded({
            alert: {
              message: descripcion || 'Ha finalizado su sesión exitosamente.',
              type: 'success'
            }
          });
        })
        .catch((error) => {
          JWT.forget();
          return Observable.of(topNavbarActions.logoutSucceeded({
            alert: { message: error.description || error.message }
          }));
        }),
    );

const verifyToken = action$ =>
  action$.ofType(appConstants.verifyToken)
    .map(({ payload: token = '' } = {}) => {
      try {
        if (JWT.validate(token)) {
          const { claim: userInfo } = JWT.read(token);
          const {
            role = '',
            roleId = null,
            ...user = {}
          } = userInfo;
          user.role = {
            id: roleId,
            name: capitalize(role)
          };
          return loginPageActions.loginSucceeded({
            data: user
          });
        }
        throw new Error();
      } catch (error) {
        if (token) {
          JWT.forget();
        }
        throw new Error();
      }
    })
    .catch(() => Observable.of(loginPageActions.loginFailed()));

export default combineEpics(
  changePassword,
  invalidToken,
  login,
  logout,
  verifyToken,
);



// WEBPACK FOOTER //
// ./src/epics/auth.js